/**
 * Registry map for entity field hydrators to break circular dependencies.
 */

export const entityFieldHydrators = new Map();
export const entityFieldHydrateInFlight = new Set();

/**
 * Register an asynchronous hydrator for a specific field.
 * @param {string} field
 * @param {(businessId: string) => Promise<unknown>} hydrateFn
 */
export function registerEntityFieldHydrator(field, hydrateFn) {
  if (!field || typeof hydrateFn !== 'function') return;
  entityFieldHydrators.set(String(field), hydrateFn);
}
